var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5.5c.552 0 1 .45 1 1.001V18.5c0 .553-.446 1.001-1 1.001h-15c-.552 0-1-.45-1-1.001V1.5C.5.948.946.5 1.5.5h15zm-1 12h-13v5h4.766c-.17-.293-.266-.634-.266-1 0-1.054.809-1.918 1.85-1.995L9 14.5c1.054 0 1.918.809 1.995 1.85l.005.15c0 .365-.097.707-.267 1.001L15.5 17.5v-5zm-13-5v3h3v-3h-3zm8 0h-3v3h3v-3zm2 0v3h3v-3h-3zm-7-2v-3h-3v3h3zm10 0v-3h-3v3h3zm-5-3h-3v3h3v-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessUnit);
export default __webpack_public_path__ + "static/media/businessUnit.49714043c6e3ebf1906a7df59372a12e.svg";
export { ForwardRef as ReactComponent };